import styles from './BaseReportModalContent.module.scss';
import { ICON_MAP } from '@components/Icons/Icons';
import { useCallback, useRef } from 'react';
import {
  BufferData,
  imageUrlToArrayBufferSimple,
  screenshotElement,
} from 'utils/captureUtils';
import { useAutoCaptureModal } from '../AutoCaptureModal/AutoCaptureModal';
import { usePanelContainer } from '@features/analysis/rendering/Panels/usePanelContainer';
import useModalActions from '@hooks/common/useModalAction';

interface BaseModalContentProps {
  className?: string;
  title?: string;
  vw?: number;
  vh?: number;
  capturebutton?: boolean;
  onCapture?: ()=> void;
  headerActions?: React.ReactNode;
  onClose: () => void;
  children: React.ReactNode;
  refelement?: React.RefObject<HTMLDivElement>;
}

export default function BaseModalContent({
  className,
  title,
  vw = 90,
  vh = 90,
  capturebutton = true,
  onCapture,
  headerActions,
  onClose,
  children,
  refelement,
}: BaseModalContentProps) {
  const CameraIcon = ICON_MAP['camera'];
  const CloseIcon = ICON_MAP['close'];
  const ref = useRef<HTMLDivElement>(null);
  const containerRef = refelement ?? ref;
  const { analysisType } = usePanelContainer();

  const AutoCaptureModalOpen = useAutoCaptureModal();

  const captureClick = async () => {
    let url = await screenshotElement(containerRef.current!);
    let buffers: BufferData[] = [];
    if (url) {
      const buffer = await imageUrlToArrayBufferSimple(url);
      buffers.push(buffer);
    }

    let name = analysisType + ' Report';
    const data = {
      buffers: buffers,
      screen_capture: true,
      capture_kind: 'Report',
      series_description: name,
    };
    AutoCaptureModalOpen('reportCapture', [data]);
  };

  const isOpeningRef = useRef(false);

  const handleCameraClick = useCallback(async () => {
    if (isOpeningRef.current) return; // ✅ 더블클릭/중복 방지
    isOpeningRef.current = true;
    try {
      await Promise.resolve((onCapture ?? captureClick)());
    } finally {
      // 필요시 쿨다운(ms) 주고 풀기: setTimeout(() => { isOpeningRef.current = false; }, 300);
      isOpeningRef.current = false;
    }
  }, [onCapture]);

  return (
    <div
      className={`${styles['main-container']} ${className? styles[className]:''}`}
      // style={{ width: `${vw}vw` }}
      ref={containerRef}
    >
      <div className={styles['main-container2']}>
        <div className={styles['header-container']}>
          <div className={styles['header']}>
            {title && <span>{title}</span>}
            {capturebutton && (
              <span className={styles['base-modal-header-svg']}> <CameraIcon onClick={handleCameraClick}/> </span>
            )}
            {headerActions && (
              <span className={styles['base-modal-header-actions']}>
                {headerActions}
              </span>
            )}
            <span onClick={onClose} className={styles['base-modal-close']} ><CloseIcon/></span>
          </div>
          <div className={styles.divider}/>
        </div>
        {/* <div className={styles['base-modal-body']}>{children}</div> */}
        {children}
      </div>
    </div>
  );
}
